define(['c21', 'c21/internationalization', 'jquery'], function (c21, internationalization, $) {
   "use strict";

   var MortgageCalculator = function () {
      var ma_mortgageCalcType = {};
      ma_mortgageCalcType.topForm = {};
      ma_mortgageCalcType.topForm.loanTerm ='input[name="loanTermPopup"]';
      ma_mortgageCalcType.topForm.annualInterest = '#mt_expectedAnnualInterestPopup';
      ma_mortgageCalcType.topForm.salePrice = '#mt_salePricePopup';
      ma_mortgageCalcType.topForm.loanAmount = '#mt_loanAmountPopup';
      ma_mortgageCalcType.topForm.propertyTax = '#mt_propertyTaxPopup';
      ma_mortgageCalcType.topForm.hazardInsurance = '#mt_hazardInsurancePopup';
      ma_mortgageCalcType.topForm.HOADues = '#mt_HOADuesPopup';
      ma_mortgageCalcType.topForm.mortgagePayment = '#mt_mortgagePaymentPopup';
      ma_mortgageCalcType.topForm.monthlyPayment = '#mt_topmonthlyPayment';
      ma_mortgageCalcType.mainForm = {};
      ma_mortgageCalcType.mainForm.loanTerm ='input[name="loanTerm"]';
      ma_mortgageCalcType.mainForm.annualInterest = '#mt_expectedAnnualInterest';
      ma_mortgageCalcType.mainForm.salePrice = '#mt_salePrice';
      ma_mortgageCalcType.mainForm.loanAmount = '#mt_loanAmount';
      ma_mortgageCalcType.mainForm.propertyTax = '#mt_propertyTax';
      ma_mortgageCalcType.mainForm.hazardInsurance = '#mt_hazardInsurance';
      ma_mortgageCalcType.mainForm.HOADues = '#mt_HOADues';
      ma_mortgageCalcType.mainForm.mortgagePayment = '#mt_mortgagePayment';
      ma_mortgageCalcType.mainForm.monthlyPayment = '#mt_topmonthlyPayment';
      // Array of the form (key,values)

      /**
       *
       * @param value -
       *            The value to check
       * @param errorIsNAN -
       *            The error to show if the value is NAN
       * @param errorIsOutOfRange -
       *            The error to show if the value is out of range
       * @param low -
       *            The lowest the value is allowed to be
       * @param high -
       *            The highest the value is allowed to be
       * @return An error message, unless the value is valid
       */
      function validateEmptyOrRangedNumberValue(value, errorIsNAN,
                                                errorIsOutOfRange, low, high) {
         if (isBlank(value) === 0) {
            if (isNaN(value) === true)
               return errorIsNAN;
            else if ((value < low) || (value > high))
               return errorIsOutOfRange;
         }
         return "";
      }

      /**
       * @param data -
       *            The data that will be checked
       * @return Whether the data is missing
       */
      function isBlank(data) {
         if (data.length === 0)
            return 1;

         for (var i = 0; i < (data.length); i++) {
            if (data.charAt(i) !== " ")
               return 0;
         }

         return 1;
      }

      /**
       * @param value -
       *            The number to validate
       * @param errorIsBlank -
       *            The error to return if the value doesn't exist
       * @param errorIsNAN -
       *            The error to return if the value is NAN
       * @param errorIsOutOfRange -
       *            The error to return if the number is too low or too high
       * @param low -
       *            Lower limit (inclusive) of the range the number must be within
       * @param high -
       *            Upper limit (inclusive) of the range the number must be within
       * @return An error message, if the number is NAN, blank, or out of range
       */
      function validateRangedNumberValue(value, errorIsBlank, errorIsNAN,
                                         errorIsOutOfRange, low, high) {
         if (isBlank(value) === 1)
            return errorIsBlank;
         else if (isNaN(value) === true)
            return errorIsNAN;
         else if ((parseInt(value) < parseInt(low)) || (parseInt(value) > parseInt(high))) {
            return errorIsOutOfRange;
         }
         return "";
      }

      /**
       * @param value -
       *            The value to clean
       * @return The given value without any commas
       */
      function cleanInput(value) {
         return value.replace(/\,/g, '');
      }

      /**
       * Sets all calculators to show the same values as in the current
       * calculator.
       *
       * @param caller -
       *            The name of the associated array (part of ma_mortgageCalc) for
       *            the intended context
       * @param arr -
       *            The array (part of ma_mortgageCalc) for the intended context
       */
      function setOtherVals(caller) {
         var myArr = {};
         myArr.loanTerm = $(caller.loanTerm).filter(':checked').val();
         myArr.annualInterest = $(caller.annualInterest).val();
         myArr.salePrice = $(caller.salePrice).val();
         myArr.loanAmount = $(caller.loanAmount).val();
         myArr.propertyTax = $(caller.propertyTax).val();
         myArr.hazardInsurance = $(caller.hazardInsurance).val();
         myArr.HOADues = $(caller.HOADues).val();
         myArr.mortgagePayment = $(caller.mortgagePayment).val();
         for ( var i in ma_mortgageCalcType) {
            if (caller !== ma_mortgageCalcType[i]) {
               $(ma_mortgageCalcType[i].loanTerm).filter(
                     '[value=' + myArr.loanTerm + ']')
                  .attr('checked', true);
               $(ma_mortgageCalcType[i].annualInterest).val(myArr.annualInterest);
               $(ma_mortgageCalcType[i].salePrice).val(myArr.salePrice);
               $(ma_mortgageCalcType[i].loanAmount).val(myArr.loanAmount);
               $(ma_mortgageCalcType[i].propertyTax).val(myArr.propertyTax);
               $(ma_mortgageCalcType[i].hazardInsurance).val(myArr.hazardInsurance);
               $(ma_mortgageCalcType[i].HOADues).val(myArr.HOADues);
               $(ma_mortgageCalcType[i].mortgagePayment).val(myArr.mortgagePayment);
               $(ma_mortgageCalcType[i].monthlyPayment).val(myArr.monthlyPayment);
            }
         }
      }

      /**
       * Add commas to the specified number
       * @param strNumber
       * @return the number with commas
       */
      function addCommas(strNumber) {
         return strNumber.replace(/(\d)(?=(\d{3})+(\.\d+)?$)/g, '$1,');
      }

      /**
       * Format a number to show in American dollars
       * @param iNumber
       * @return the resulting currency (ex: $1023.51)
       */
      function formatCurrency(iNumber) {
         var strRoundedNumber = iNumber.toFixed(0);
         return '$' + addCommas(strRoundedNumber);
      }

      /**
       * Calculates the monthly payment and puts it into the payment fields.
       *
       * @param alertFlag -
       *            Whether to alert the user about invalid input
       * @param params -
       *            an array of the order specified in mortgageCalc, in the order:
       *            term,interest,price,loan amount, tax, hazard, HOA, monthly
       *            payment, and top-of-page monthly payment. Term is expected to
       *            be a radio button with number values, and all else is expected
       *            to be text input boxes.
       * @return Whether the fields were valid
       */
      function mainCalcMortgage(alertFlag, params) {
         //Get the JQuery objects for each part of the mortgage calculator form
         var $term = $(params.loanTerm).filter(':checked');
         var $interest = $(params.annualInterest);
         var $price = $(params.salePrice);
         var $amount = $(params.loanAmount);
         var $tax = $(params.propertyTax);
         var $hazard = $(params.hazardInsurance);
         var $hoa = $(params.HOADues);
         var $payment = $(params.mortgagePayment);
         var $topPayment = $(params.monthlyPayment);
         //Get the values needed for calculation, from each form field, cleaning them of invalid inputs
         var loanTerm = $term.val();
         var interestRate = cleanInput($interest.val().replace(/[^0-9\.]+/g, ""));
         var loanAmount = cleanInput($amount.val().replace(/[^0-9\.]+/g, ""));
         var propertyTaxes = cleanInput($tax.val().replace(/[^0-9\.]+/g, ""));
         var hazardInsurance = cleanInput($hazard.val()
            .replace(/[^0-9\.]+/g, ""));
         var hoaDues = cleanInput($hoa.val().replace(/[^0-9\.]+/g, ""));
         var homePrice = cleanInput($price.val().replace(/[^0-9\.]+/g, ""));
         //Prepare the error message (if needed) by filtering for problems in the mortgage calculator field values

         var strErrorMessage = '';
         strErrorMessage += internationalization.getString(validateRangedNumberValue(interestRate,
            "Please enter your interest rate.",
            "The value for interest rate should be free of special characters or letters.",
            "The value for interest rate should be greater than 0% and less than 51%.",
            1, 50));
         strErrorMessage += internationalization.getString(validateRangedNumberValue(loanAmount,
            "Please enter your loan amount.",
            "Your loan amount should be free of special characters or letters.",
            "Your loan amount should be greater than $20000 and less than $1,000,000,000.",
            20001, 99999999));
         strErrorMessage +=  internationalization.getString(validateEmptyOrRangedNumberValue(propertyTaxes,
            "Your property taxes value should be free of special characters or letters.",
            "Your property taxes value should be a minimum of $0 and less than $1,000,000,000.",
            0, 99999999));
         strErrorMessage += internationalization.getString(validateEmptyOrRangedNumberValue(hazardInsurance,
            "Your hazard insurance value should be free of special characters or letters.",
            "Your hazard insurance value should be a minimum of $0 and less than $1,000,000,000.",
            0, 99999999));
         strErrorMessage +=  internationalization.getString(validateEmptyOrRangedNumberValue(hoaDues,
            "Your homeowner's association dues value should be free of special characters or letters.",
            "Your homeowner's association dues value should be a minimum of $0 and less than $1,000,000,000.",
            0, 99999999));
         strErrorMessage += internationalization.getString(validateRangedNumberValue(homePrice,
            "Please enter the sales price of the home.",
            "The sales price or the estimated value of the home should be free of special  characters or letters.",
            "The sales price or the estimated value of the home should be greater than $0 and less than $1,000,000,000.",
            0, 99999999));

         var strLoanError = internationalization.getString("Please select one of the provided loan terms.");
         strErrorMessage += validateRangedNumberValue(loanTerm,
            strLoanError,
            strLoanError,
            strLoanError,
            0, 99999999);

         //Make several important values into numbers
         var lamount = Number(loanAmount);
         var hprice = Number(homePrice);

         if (lamount > hprice)
            strErrorMessage += internationalization.getString("The loan amount cannot be greater than the expected sales price/estimated value of the home");

         //Allow the calculation to take place & display if there were no errors
         if (strErrorMessage.length === 0) {
            var LTV = (lamount / hprice);
            var PMIRate = true;
            var LTVThreshold = 0.800;

            if (LTV <= LTVThreshold) {
               PMIRate = false;
            }

            if (PMIRate) {
               if ((LTV < 0.85) || (LTV === 0.85)) {
                  PMIRate = 0.0032;
               } else if ((LTV < 0.90) || (LTV === 0.90)) {
                  PMIRate = 0.0052;
               } else if ((LTV < 0.95) || (LTV === 0.95)) {
                  PMIRate = 0.0078;
               } else {
                  PMIRate = 0.0090;
               }
            }

            var mi = interestRate / 1200;
            var base = 1;
            var mbase = 1 + mi;

            for (var i = 0; i < (loanTerm * 12); i++) {
               base = base * mbase;
            }

            //This is the final result
            var dasum = lamount * mi / (1 - (1 / base)) + propertyTaxes / 12 + hoaDues / 12 + loanAmount * (PMIRate / 12) + hazardInsurance / 12;
            var monthlyPayment = formatCurrency(dasum);
            $payment.val(monthlyPayment);//Post the result to the input box for monthly payments
            $topPayment.text(monthlyPayment);//Post the result as the main number for monthly payments
            $("#mcTop .calcErrors").html("");
            return true;
         } else {//Don't do the calculation, and display an alert message in this is allowed to display alerts; only happens if some values are invalid
            $payment.val("");
            // If there's an error message, try to show it
            if (alertFlag) {
               $("#mcTop .calcErrors").html(internationalization.getString("Before continuing, the following fields require attention: ") + "\n" + strErrorMessage);
            }
         }
         return false;
      }

      /**
       * Sets all calculators to show the same values as in the main
       * calculator.
       */
      function setToMainVals(){
         var caller = ma_mortgageCalcType.mainForm;
         setOtherVals(caller);
      }

      /**
       * Sets all calculators to show the same values as in the top
       * calculator.
       */
      function setToTopVals(){
         var caller = ma_mortgageCalcType.topForm;
         setOtherVals(caller);
      }

      /**
       * Calculate the monthly payment and silently fail on errors - for the side
       * calculator
       */
      function calcMortgageSilent() {
         var caller = ma_mortgageCalcType.mainForm;
         mainCalcMortgage(false, caller);
         setOtherVals(caller);
      }

      /**
       * Calculate the monthly payment and show an alert on errors - for the side
       * calculator
       */
      function calcMortgage() {
         var caller = ma_mortgageCalcType.mainForm;
         mainCalcMortgage(true, caller);
         setOtherVals(caller);
      }

      /**
       * Calculate the monthly payment and silently fail on errors - for the top
       * calculator
       */
      function calcMortgageSilentTop() {
         var caller = ma_mortgageCalcType.topForm;
         mainCalcMortgage(false, caller);
         setOtherVals(caller);
      }

      /**
       * Calculate the monthly payment and show an alert on errors - for the top
       * calculator
       */
      function calcMortgageTop() {
         var caller = ma_mortgageCalcType.topForm;
         mainCalcMortgage(true, caller);
         setOtherVals(caller);
      }

      return {
         setToMainVals : setToMainVals,
         setToTopVals : setToTopVals,
         calcMortgageSilent : calcMortgageSilent,
         calcMortgage : calcMortgage,
         calcMortgageSilentTop : calcMortgageSilentTop,
         calcMortgageTop : calcMortgageTop
      };
   };

   return MortgageCalculator;

});
